export const formatPhone = (phone: string): string => {
  if (!phone) return ``
  let corrected = phone.replace(/[^0-9]/g, ``)
  const phoneLength = corrected.length
  // remove country code
  if (phoneLength === 11) {
    corrected = corrected.substring(1, corrected.length)
  }
  // remove extension
  if (corrected.length === 14) {
    corrected = corrected.substring(1, 11)
  }

  return (
    `(` +
    corrected.substring(0, 3) +
    `) ` +
    corrected.substring(3, 6) +
    `-` +
    corrected.substring(6, 10)
  )
}
